import { Link } from 'react-router-dom'
import { LogoMark, SectionContainer } from '@/components/shared'
import { websiteContent } from '../content'
import { usePanelViewTracking } from '../hooks/usePanelViewTracking'

const { footer } = websiteContent

function FooterSection() {
  usePanelViewTracking({
    panelId: 'footer',
    panelName: 'Footer',
    panelIndex: 6,
  })

  return (
    <SectionContainer
      id="footer"
      as="footer"
      size="page"
      className="bg-gray-darkest min-h-[456px] pb-6 pt-16 text-white md:min-h-0 md:pb-24 md:pt-[72px] 3xl:pb-[120px] 3xl:pt-[88px]"
      innerClassName="relative"
    >
      <div className="max-w-[265px] space-y-6 md:max-w-[330px]">
        <h2 className="font-archivo text-[32px] font-extralight leading-[46px] text-white md:text-h2">
          {footer.title}
        </h2>
        <p className="text-body-md font-archivo font-light text-gray-light">
          {footer.subtitle}
        </p>
      </div>

      <div className="mt-10 flex flex-wrap items-center justify-start gap-10 text-body-sm font-archivo font-light text-gray-light md:mt-12 md:justify-end">
        <span>{footer.copyright}</span>
        <Link className="text-brand-greenBright" to="/privacy-policy">
          {footer.privacyLabel}
        </Link>
      </div>

      <div className="mt-6 h-[102px] w-full max-w-[361px] p-0 md:mt-0 md:h-[395px] md:max-w-none md:p-6 3xl:h-[531px]">
        <LogoMark size="lg" variant="light" className="h-full w-full" />
      </div>
    </SectionContainer>
  )
}

export default FooterSection
